import {AxiosResponse} from 'axios';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';

export interface Term {
  id: number;
  parameter: string;
  value: string;
  modified: string;
}

export const fetchTermsService = (): Promise<AxiosResponse<Term>> =>
  letrusAPI(`/api/v1/terms/`);
